exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bridge{z-index:1\n}\n.body{background-color:rgba(0,0,119,.7333333333)\n}\n@media(max-width: 979px){\n.logo{display:none\n}\n}\n.logo{position:absolute;top:25px;left:25px;z-index:2\n}\n.lato{font-family:\"Lato\",sans-serif\n}\n.dropdown{font-size:large\n}\n.outer-div{position:absolute;top:30px;right:0;left:0;z-index:13\n}\n.inner-div{margin:0 auto;margin-top:200px;width:500px\n}\n.b-jumbotron{background-color:#125697 !important\n}\n.b-jumbotron .font-family{font-family:\"Lato\",sans-serif !important\n}", ""]);

// exports
